import { z } from 'zod';
import { ApiChatMessageKind, type ChatDialogMessageResponse } from '@/core/generated/api';
import { requiredString } from '@/shared/lib/validation';

const namedItem = z.object({
    id: z.number()
        .int()
        .positive(),
    name: requiredString(undefined, { trim: false }),
});

const eventSchema = z.discriminatedUnion('event', [
    z.object({
        event: z.literal('state_changed'),
        old: namedItem,
        new: namedItem,
        order_id: z.number()
            .int()
            .positive(),
    }),
    z.object({
        event: z.literal('list_added'),
        list: namedItem,
        tag: z.boolean(),
    }),
]);

/** Показывает известные служебные события SaleBot понятным текстом */
export const getChatDialogMessageText = (message: ChatDialogMessageResponse): string => {
    const text = message.text ?? '';

    if (message.kind?.id !== ApiChatMessageKind.System) return text;

    try {
        const value: unknown = JSON.parse(text);
        const parsed = eventSchema.safeParse(value);

        if (!parsed.success) return text;

        const event = parsed.data;

        if (event.event === 'state_changed') {
            return `Статус сделки №${event.order_id}: «${event.old.name}» → «${event.new.name}»`;
        }

        return event.tag
            ? `Добавлена метка «${event.list.name}»`
            : `Добавлен в список «${event.list.name}»`;
    } catch {
        return text;
    }
};
